import { useEffect, useRef } from 'react';
import './TextWithDropCap.css';

function TextWithDropCap({ text }: { text: string }) {
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!contentRef.current || !text) return;

        // Parse the HTML content
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(text, 'text/html');

        // Find all paragraphs in the parsed content
        const paragraphs = htmlDoc.querySelectorAll('p');

        if (paragraphs.length > 0) {
            const firstParagraph = paragraphs[0];
            const paragraphText = firstParagraph.textContent || '';

            if (paragraphText.length > 0) {
                const firstLetter = paragraphText.charAt(0);
                const restOfText = paragraphText.slice(1);

                // Create drop cap span for the first letter
                const dropCapSpan = document.createElement('span');
                dropCapSpan.className = 'drop-cap';
                dropCapSpan.textContent = firstLetter;

                // Create span for rest of text
                const restSpan = document.createElement('span');
                restSpan.textContent = restOfText;

                // Clear the paragraph and add our new spans
                firstParagraph.textContent = '';
                firstParagraph.appendChild(dropCapSpan);
                firstParagraph.appendChild(restSpan);

                // Preserve original styles from CKEditor
                if (firstParagraph.getAttribute('style')) {
                    firstParagraph.style.textAlign = 'justify';
                }
            }
        }

        // Set the modified content to our ref
        contentRef.current.innerHTML = htmlDoc.body.innerHTML;
    }, [text]);

    return <div ref={contentRef} className="drop-cap-content"></div>;
}

export default TextWithDropCap;
